import { ChecklistNotifiable, ChecklistNotifiableSendable } from '@/entities/checklistNotifiable';
import { scoreTriggerIntoEditable, scoreTriggerIntoSendable } from '@/services/api/resources/scoreTrigger';
import { ChecklistNotifiableEditable } from '@/ui/DTO';

export const intoSendable = (resource: ChecklistNotifiableEditable): ChecklistNotifiableSendable => ({
  ...(resource.id ? { id: resource.id! } : {}),
  externalAssociates: resource.externalAssociates,
  users: resource.users,
  entityItemSpecificAssignments: resource.entityItemSpecificAssignments,
  scoreTrigger: scoreTriggerIntoSendable(resource.scoreTrigger),
});

export const intoEditable = (resource: ChecklistNotifiable): ChecklistNotifiableEditable => ({
  id: resource.id,
  externalAssociates: resource.externalAssociates.map(a => a.email),
  users: resource.users,
  entityItemSpecificAssignments: resource.entityItemSpecificAssignments,
  scoreTrigger: scoreTriggerIntoEditable(resource.scoreTrigger),
});
